import React from 'react';
export class ContextMenu extends React.Component {
    constructor(props) {
        super(props);
        this._div = undefined;
        this.state = {
            items: this.props.items || [],
            show: this.props.show || false,
            x: this.props.x || 0,
            y: this.props.y || 0
        };
    }
    componentDidMount() {
        if (this._div !== undefined) {
            this._div.focus();
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.items || [],
            show: nextProps.show || false,
            x: nextProps.x || 0,
            y: nextProps.y || 0
        });
    }
    render() {
        return (React.createElement("div", { tabIndex: 0, style: {
                position: "absolute",
                left: this.state.x,
                top: this.state.y,
                display: this.state.show ? 'block' : 'none',
                padding: '8px',
                boxShadow: 'rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px',
                background: 'white',
                border: 'solid 1px silver',
                minWidth: '200px',
                cursor: 'pointer',
                userSelect: 'none'
            }, onBlur: () => {
                this.setState({
                    show: false
                }, () => this.props.onClose());
            }, ref: e => {
                this._div = e;
                if (this._div != null) {
                    this._div.focus();
                }
            } }, this.state.items.map(o => {
            return React.createElement("div", { style: {
                    padding: '8px'
                }, onClick: () => {
                    o.onClick();
                    this.props.onClose();
                } }, o.text);
        })));
    }
}
